



























































import ThgQuoteExportDialog from "@/components/thg/ThgQuoteExportDialog.vue";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { Component } from "vue-property-decorator";
import FilterCard from "@/components/filter/FilterCard.vue";
import { CounterModule } from "@/store/modules/counter.store";
import { BillingModule } from "@/store/modules/billing.store";
import { ThgCreateBillingThgDtoGen } from "@/services/thg/v1/data-contracts";
import { UserAdministrationModule } from "@/store/modules/admin-user.store";
import ThgBillingCreditorSelectionUserList from "./ThgBillingCreditorSelectionUserList.vue";
import { BillingTypeEnum } from "@/lib/enum/billingType.enum";

@Component({ components: { ThgQuoteExportDialog, FilterCard, ThgBillingCreditorSelectionUserList } })
export default class ThgBillingCreateNewBillingManual extends DarkModeHighlightMixin {
  counterLoading = false;

  loadingCreateBilling = false;

  loadingAllUsers = false;

  newBilling: ThgCreateBillingThgDtoGen = {
    userId: undefined,
    accountNumber: undefined,
    thgId: undefined,
    partnerId: undefined,
    type: BillingTypeEnum.CREDIT,
    isPublished: false
  };

  /**
   * Gets all labels for the available billing types
   */
  get typeLabels() {
    return Object.values(BillingTypeEnum).map((b: string) => {
      return this.i18n[b];
    });
  }

  /**
   * gets the billing type
   */
  get type() {
    return this.i18n[this.newBilling.type];
  }

  /**
   * Sets billing type by checking what is the type for the selected label
   */
  set type(t: string) {
    for (const billingType of Object.values(BillingTypeEnum)) {
      if (t === this.i18n[billingType]) {
        this.newBilling.type = billingType;
      }
    }
  }

  /**
   * BillingTypeEnum
   */
  get BillingTypeEnum() {
    return BillingTypeEnum;
  }

  /**
   * Internationalization
   */
  get i18n() {
    return this.$t("components.thg.thgBillingCreateNewBillingManual");
  }

  get allUsers() {
    return UserAdministrationModule.users;
  }

  get userId(): any {
    return this.newBilling.userId;
  }

  set userId(value: any) {
    this.newBilling.userId = value._id;
  }

  get billingNumber() {
    return CounterModule.counterSequence;
  }

  get counter() {
    return CounterModule.counterSequence;
  }

  userIdSelection(userId: string) {
    this.newBilling.userId = userId;
  }

  async mounted() {
    try {
      await this.loadCounterValue();
    } catch (e) {
      this.$log.error(e);
      this.$toast.error((e as any).message);
    }
    this.loadingAllUsers = true;

    try {
      await UserAdministrationModule.getUsers();
    } catch (e) {
      this.$log.error(e);
      this.$toast.error((e as any).message);
    } finally {
      this.loadingAllUsers = false;
    }
  }

  async loadCounterValue() {
    this.counterLoading = true;
    try {
      await CounterModule.getCounterController("billing");
    } catch (e) {
      this.$log.error(e);
      this.$toast.error((e as any).message);
    } finally {
      this.counterLoading = false;
    }
  }

  async createNewBilling() {
    this.loadingCreateBilling = true;
    try {
      await BillingModule.createBilling(this.newBilling);
    } catch (e) {
      this.$log.error(e);
      this.$toast.error((e as any).message);
    } finally {
      this.loadingCreateBilling = false;
      this.$emit("created");
    }
  }
}
